import React from "react";
import {connect} from "react-redux";
import Tooltip from "components/Tooltip";
import PropTypes from 'prop-types';
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import {FormattedMessage} from "react-intl";
import Button from "components/Button";
import {deleteAttribute} from "../../../../../../../../../../../../../../../../../../../data/attributes/actions";

function DeleteAttribute(props){
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggleModalOpen = () => setModalOpen(!modalOpen);
  const [deleting, setDeleting] = React.useState(false);

  const onDelete = () => {
    setDeleting(true);

    props.deleteAttribute(props.attribute)
    .then(() => {
      setDeleting(false);
      toggleModalOpen();
    })
    .catch(() => {
      setDeleting(false);
      toggleModalOpen();
    })
  }

  return <React.Fragment>
    <i id={'delete-attribute-' + props.attribute.id} onClick={toggleModalOpen} className="fas fa-times pointer p-2 text-danger" />
    <Tooltip id={'delete-attribute-' + props.attribute.id} msg={'Usuń atrybut'} />
    {modalOpen && <Modal isOpen={true} toggle={toggleModalOpen} size="lg">
      <ModalHeader tag="h2" toggle={toggleModalOpen}>Potwierdź usunięcie atrybutu</ModalHeader>
      <hr className="my-0"/>
      <ModalBody>
        Czy na pewno usunąć atrybut?
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" className={['mb-0']} onClick={toggleModalOpen}>{message}</Button>
        }</FormattedMessage>
        <FormattedMessage id="_.button.delete">{
          (message) => <Button
            color="danger"
            loading={deleting}
            onClick={onDelete}
          >
            {message}
          </Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>}
  </React.Fragment>
}

DeleteAttribute.propTypes = {
  attribute: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default connect(null, {deleteAttribute})(DeleteAttribute);